import type { AllRouteEndpoints } from "../routeTypes";

export const engagementWebhookTemplatesUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/webhook_templates/:id",
  "/engagement/webhook_templates",
  "/engagement/webhook_templates/tags",
];
